let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e8HfG")).then(() => parcelRequire('aIx48'));